import { StoryblokTextOnImageCol } from './StoryblokTextOnImageCol'

import { createTextOnImageCol } from './__mocks__/textOnImageCol'

export { createTextOnImageCol }

// Re-export for backward compatibility
export const dummyBlokTextOnImageColStoryblok = createTextOnImageCol()

export default StoryblokTextOnImageCol
